<template>
  <div class="app-main-content bill-overseas-s-center-view">
    <div
      class="main-content"
      type="primary"
    >
      <query-bill-oversea-condition
        ref="queryBillOverseaCondition"
        :source-submit-state="4"
        :bill-state="4"
      >
        <template slot="operations">
          <div style="float: left;">
            <el-button style="margin-left: 10px" type="primary" @click="toQuery()">
              {{ $t('CargoMsg.Cargo_Query') }}
            </el-button>
            <el-button v-show="$checkPermission(['button_BillOverseasSCenter_accept'])" type="primary" @click="toSubmit()">{{ $t('CargoMsg.Cargo_Receive') }}</el-button>
            <el-button v-show="$checkPermission(['button_BillOverseasSCenter_billOverseasReturn'])" type="primary" @click="toReturn()">{{ $t('CargoMsg.Cargo_Return') }}</el-button>
            <el-button type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_ResetFilter') }}</el-button>
            <el-button type="primary" @click="onPrint()">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          </div>
        </template>
      </query-bill-oversea-condition>
    </div>
    <bill-overseas-s-submit-grid
      config-module="410015202"
      :row-data="rowData"
      :filter="filter"
      :grid-options="gridOptions"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-select-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :ctx="templateSelectorDialog.ctx"
    />
  </div>
</template>

<script>
import QueryBillOverseaCondition
  from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/query/queryBillOverseaCondition'
import { getLoading } from '@/utils/utilBaseElement'
import AmountSumMaster from '@/views/cargo/v0/Clearing/components/FinanceChargeSearch/AmountSumMaster'
import { queryBillOverseas, batchUpdateStates } from '@/api/clearing/billingNative'
import StrUtils from '@/utils/StrUtils'
import BillOverseasSSubmitGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billOverseasSSubmitGrid'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
export default {
  name: 'BillOverseasSSubmitView',
  components: { CargoTemplateSelectDialog, BillOverseasSSubmitGrid, AmountSumMaster, QueryBillOverseaCondition },
  data() {
    return {
      fullscreenLoading: null,
      rowData: [],
      isBack: false,
      numAll: 100,
      numSelected: 0,
      sumCredit: '',
      sumDebit: '',
      selectedRows: [],
      filter: {
        pageNum: 1,
        pageSize: 100
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'BILLING',
        data: {},
        ctx: null,
        printedCallback: null
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: (event) => {
          this.selectedRows = event.api.getSelectedRows()
        }
      }
    }
  },
  methods: {
    toQuery() {
      const option = this.$refs['queryBillOverseaCondition'].getSearchOption()
      if (option.isMerge && !option.hasOwnProperty('accountId')) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
        return
      }
      option['limit'] = this.filter.pageSize
      this.fullscreenLoading = getLoading()
      queryBillOverseas(option).then(res => {
        this.rowData = res.data
        this.loadingEnd()
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      this.isBack = false
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
      this.selectedRows = []
    },
    toReturn() {
      this.isBack = true
      this.updateState()
    },
    toSubmit() {
      this.isBack = false
      this.updateState()
    },
    // 退回,接受
    updateState() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      for (const billing of selectRows) {
        if (StrUtils.isEmpty(billing.billingNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted'))
          return
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureDoThis'), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        if (this.checkSubmitBilling()) {
          // 退回到已打印状态
          this.fullscreenLoading = getLoading()
          batchUpdateStates(selectRows, { state: this.isBack ? 2 : 5 }).then(res => {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
            this.gridOptions.api.updateRowData({ 'remove': selectRows })
            this.loadingEnd()
          }).catch(() => {
            this.fullscreenLoading.close()
          })
        }
      })
    },
    checkSubmitBilling() {
      for (const bill of this.selectedRows) {
        if (bill.state !== 4) {
          this.$message.warning(StrUtils.substitute(this.$t('CargoMsg.Cargo_BillWasNotSubmitted'), bill.billingNo))
          return false
        }
      }
      return true
    },
    resetSearch() {
      this.$refs['queryBillOverseaCondition'].resetSearch()
    },
    onPrint() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      const keyList = []
      for (const billing of selectRows) {
        keyList.push(billing.key)
      }
      const params = {
        BILLING_UUID_LIST: keyList,
        BILLING_UUID: keyList
      }
      // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
      if (selectRows.length === 1) {
        params['billingNo'] = selectRows[0].billingNo
        if (!StrUtils.isEmpty(selectRows[0].jobNo)) {
          params['jobNo'] = selectRows[0].jobNo
        }
      }
      this.templateSelectorDialog.visible = true
      this.templateSelectorDialog.ctx = null
      this.templateSelectorDialog.data = params
    }
  }
}
</script>

<style lang="scss">
.bill-overseas-s-center-view{
  .totalLabel{
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
